var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pages"},_vm._l((_vm.curPageArr),function(item){return _c('span',{class:{ 'cur': _vm.curPage == item },on:{"click":function($event){return _vm.pageChange(item)}}},[_vm._v(_vm._s(item))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }